import { render, staticRenderFns } from "./QNAWrite.vue?vue&type=template&id=a808d0f8&scoped=true"
import script from "./QNAWrite.vue?vue&type=script&lang=js"
export * from "./QNAWrite.vue?vue&type=script&lang=js"
import style0 from "./QNAWrite.vue?vue&type=style&index=0&id=a808d0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a808d0f8",
  null
  
)

export default component.exports